import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { FlaggedCaseEmailFilterParameterDialog } from "../Ui/Dialogs/FlaggedCaseEmailFilterParameterDialog";

export type EntityCommandFlaggedCaseEmailFilterPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandFlaggedCaseEmailFilterProperties = {
    [name in keyof EntityCommandFlaggedCaseEmailFilterPropertyValues]: Property<EntityCommandFlaggedCaseEmailFilterPropertyValues[name]>
};

export interface IEntityCommandFlaggedCaseEmailFilter extends IEntityCommand, EntityCommandFlaggedCaseEmailFilterProperties
{
}

export class EntityCommandFlaggedCaseEmailFilter extends EntityCommand implements IEntityCommandFlaggedCaseEmailFilter
{
    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandFlaggedCaseEmailFilterPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Filter",
                entityName: "FlaggedCaseEmail",
                key: "FILTER",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entitySet,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        const
            caller = entityCommandInformation.caller.get();

        if (!caller.flaggedCaseEmailFilterParameterDialog)
            caller.flaggedCaseEmailFilterParameterDialog = new FlaggedCaseEmailFilterParameterDialog();

        const
            flaggedCaseEmailFilterParameterDialog = caller.flaggedCaseEmailFilterParameterDialog as FlaggedCaseEmailFilterParameterDialog;

        await (
            flaggedCaseEmailFilterParameterDialog
                .openAsync()
                .then(result =>
                {
                    if (result.dialogResult !== DialogResultEnum.ok)
                        return;

                    caller.currentFilter = result.promiseData;
                })
        );
    }

    // #endregion

    // #endregion
}

